// extracted by mini-css-extract-plugin
export default {"formTitle":"FormHeader_formTitle__MCqNc","alert":"FormHeader_alert__pf7N+","alertDanger":"FormHeader_alertDanger__GQrL8"};